import React from 'react';
import PropTypes from 'prop-types'
import {CircleWithIcon} from './Common'
import constant from './utils/constant'
import {ErrorIcon} from '../../images/'


const ErrorBox = (props) => {
  const {classNames} = props;
  const color = constant.COLOR.BACK_COLOR_OF_CIRCLE_HAS_ICON;
  return (
      <div className={`error ${classNames}`}>
        <CircleWithIcon
            classNames="icon-wrapper"
            backColor={color.ERROR}
            ChildComponent={ErrorIcon}
        />
        <div className="text">
          <div>متاسفانه خطایی رخ داده است!</div>
          <div>دوباره تلاش کنید.</div>
        </div>
      </div>
  )
};

ErrorBox.propTypes = {
  classNames: PropTypes.string,
};

ErrorBox.defaultProps = {
  classNames: ""
};

export default ErrorBox
